export default __webpack_public_path__ + "static/media/outlook.156e5d0c.svg";